import React from 'react';
import BasicInformation from '../Classes/BasicInformation';
import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import CardsInformation from '../DevelopmentalRubric/CardsInformation';
import TextValue from '../../../../../text/TextValue';
import UserInfo from '../User/UserInfo';
import UserChip from '../../../../../chip/UserChip';
import LogCardMin from './LogCardMin';
import CardKeyValue from '../../../../../card/cardKeyValue';
import { getValueElement } from '../../TableCompare/utils';

const MarkingClass = ({ detail, action }) => {
  return (
    <div className='pt-4'>
      <TextValue title='Curriculum' value={detail?.curriculum || <TextNotAssigned />} />
      {detail.class && (
        <>
          <Typography variant='subtitle1' color='primary' className='font-bold text-center py-2'>
            Class
          </Typography>
          <BasicInformation detail={detail.class} />
        </>
      )}
      {detail.dr && (
        <>
          <Typography variant='subtitle1' color='primary' className='font-bold text-center py-2'>
            Unit of learning
          </Typography>
          <CardsInformation detail={detail.dr} />
        </>
      )}
      {detail.lc && (
        <>
          <Typography variant='subtitle1' color='primary' className='font-bold text-center py-2'>
            Learning continuum
          </Typography>
          <div className='flex gap-4 flex-wrap justify-center'>
            {Object.keys(detail.lc.lcElements).length > 0 ? (
              detail.lc.lcElements.map((key) => (
                <CardKeyValue
                  key={key}
                  className='min-w-200px max-w-250px'
                  title={key.name}
                  value={key.definition}
                />
              ))
            ) : (
              <></>
            )}
          </div>
        </>
      )}
      {detail.student && (
        <>
          <Typography variant='subtitle1' color='primary' className='font-bold text-center py-2'>
            Student
          </Typography>
          <UserInfo user={detail.student} />
        </>
      )}
      {detail.students && detail?.students?.length > 0 && action !== 'group marking' && (
        <>
          <Typography variant='subtitle1' color='primary' className='font-bold text-center py-2'>
            Students
          </Typography>
          <div className='grid grid-cols-4 gap-2'>
            {detail.students.map((student, index) => (
              <UserChip key={index} {...student} name={student.fullName} />
            ))}
          </div>
        </>
      )}
      {detail.markingData && (
        <div
          className={[
            'grid gap-2 justify-center',
            ['bulk marking', 'group marking'].includes(action) ? '' : 'grid-cols-2'
          ].join(' ')}
        >
          {action === 'group marking' ? (
            <>
              <Typography variant='subtitle1' color='primary' className='font-bold text-center py-2'>
                Students ({detail?.students?.length || 0})
              </Typography>
              {detail.students && detail?.students?.length > 0 && (
                <Table className='w-full'>
                  <TableHead>
                    <TableRow>
                      <TableCell>Student</TableCell>
                      <TableCell>Logs</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {detail.students.map((student, index) => {
                      const find = detail?.markingData?.find((item) => item.studentId === student._id);
                      return (
                        <TableRow key={`student-marking-${student._id}-${index}`}>
                          <TableCell>
                            <UserChip
                              name={student?.fullName}
                              {...student}
                              variant='outlined'
                              className='border-none min-w-350px'
                              maxWidth='350px'
                            />
                          </TableCell>
                          <TableCell>
                            {find?.logMarking
                              ?.sort((a, b) => new Date(b.date) - new Date(a.date))
                              ?.map((log, index) => (
                                <LogCardMin
                                  id={`old-marking-log-${log._id}-${index}`}
                                  key={`old-marking-log-${log._id}-${index}`}
                                  log={log}
                                />
                              ))}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              )}
            </>
          ) : (
            <>
              <div className='flex flex-col gap-2'>
                {action !== 'bulk marking' && (
                  <>
                    <Typography variant='subtitle1' color='primary' className='font-bold text-center py-2'>
                      Old marking
                    </Typography>
                    {detail?.markingData?.old?.logMarking
                      ?.sort((a, b) => new Date(b.date) - new Date(a.date))
                      ?.map((log, index) => (
                        <LogCardMin
                          id={`old-marking-log-${log._id}-${index}`}
                          key={`old-marking-log-${log._id}-${index}`}
                          log={log}
                        />
                      ))}
                  </>
                )}
              </div>
              <div className='flex flex-col gap-2'>
                <Typography variant='subtitle1' color='primary' className='font-bold text-center py-2'>
                  New marking
                </Typography>
                {detail?.markingData?.new?.logMarking
                  ?.sort((a, b) => new Date(b.date) - new Date(a.date))
                  ?.map((log, index) => (
                    <LogCardMin
                      id={`old-marking-log-${log._id}-${index}`}
                      key={`old-marking-log-${log._id}-${index}`}
                      log={log}
                    />
                  ))}
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MarkingClass;
